import React from 'react';
import AboutPage from '../components/AboutPage';
import WhatsAppButton from '../components/WhatsAppButton';

function AboutUs() {
  return (
    <div className="home">
      <AboutPage /> 
      <WhatsAppButton />
    </div>
  );
}

export default AboutUs;
